export default "__VITE_ASSET__CWb261o1__"